import {
  SectionTitle,
  SectionSubTitle,
  SectionDivider,
  Container
} from "./styles";

interface SectionHeaderProps {
  title: string
  subTitle: string
}
const SectionHeader = ({
  title = '',
  subTitle = ''
}: SectionHeaderProps) => {
  return (
    <Container>
      <SectionTitle>
        {title}
      </SectionTitle>
      <SectionSubTitle>
        {subTitle}
      </SectionSubTitle>
      <SectionDivider />
    </ Container>
  );
};

export default SectionHeader;
